import { useStyles } from "./styles";
import { Table, TableHead, TableBody, TableRow, TableCell, Typography, CircularProgress, Box, Grid } from '@material-ui/core';
import { TableDataStruct } from 'interfaces/Datastructures';
import { useEffect, useState } from "react";
import { axiosHelperWithToken } from "utils/axios";
import { useDispatch } from "react-redux";
import { showNotification } from "store/slices/snackbar/snackbarSlice";
import classNames from 'classnames';

function AdminDashboard() {
  const classes = useStyles();
  const axios = axiosHelperWithToken();
  const dispatch = useDispatch();
  const [tableData, setTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const axios = axiosHelperWithToken();
    axios.get('/Users/all-users').then((response) => {
      setTableData(response.data);
    }).catch(() => {
      dispatch(showNotification({ message: 'An error has occurred', variant: "error" }));
    }).finally(() => {
      setIsLoading(false);
    });
  }, [dispatch]);
  const cellTitles = [
    'First Name',
    'Last Name',
    'Email',
    'Type',
    'Organization',
    'Verified?'
  ];

  const keyOrder = [
    'firstName',
    'lastName',
    'email',
    'userAccounts',
    'organization',
    'isVerified'
  ];

  return (<Grid xs={10} item className={classes.adminListViewWrapper}>
    <div>
      <Typography component="h1" variant="h5" color="inherit" gutterBottom className={classes.usersHeader}>
        All Users
      </Typography>
    </div>
    <Table>
      {isLoading ? <div style={{ margin: '0 auto', textAlign: 'center' }}><CircularProgress disableShrink /></div> :
        <>
          <TableHead>
            <TableRow>
              {cellTitles.map(titleText => {
                return (
                  <TableCell key={titleText} className={classNames(classes.tableCell, classes.stickyHeader)}><b>{titleText}</b></TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {!isLoading && tableData.length === 0 ?
              <div>No results</div>
              : null}
            {!isLoading && tableData.map((rowData: TableDataStruct, index: number) => {
              return (
                <TableRow key={`row${index}`}>
                  {keyOrder.map((key: string, cellIndex: number) => {
                    let value = rowData[key];
                    if (key === "isVerified") {
                      value = rowData[key] ? "Yes" : "No"
                    }
                    if (key === "userAccounts") {
                      value = (rowData[key] as any)?.map((t: any) => t.userType).join(",")
                    }
                    return (
                      <TableCell key={`cell${cellIndex}`} className={classes.tableCell}>{value}</TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </>}
    </Table></Grid>)
}

export default AdminDashboard
